
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(889|97)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
